import React from 'react';
import './Hero.css';

const HeroSection = () => {
  return (
    <section className="hero">
    <div className="hero-content">
      <h1 className="hero-title">YOU ARE NOT <br /> SPECIAL</h1>
    </div>
  </section>
  

  );
};

export default HeroSection;
